import api from './api';

export const getSimpleServicePages = (currentPage, PageSize, search, config) => {
	let errors = [];
	if (!currentPage) {
		errors.push("current page");
	}
	if (!PageSize) {
		errors.push("page size");
	}
	if (!config) {
		errors.push("config");
	}
	if (errors.length) {
		return Promise.reject(Error(`${errors.join(", ")} parameters are missing!`));
	} else {
		return api.get(
			`/ServiceContent/AllServiceDynamicContentSimple?PageNumber=${currentPage}&PageSize=${PageSize}&search=${encodeURIComponent(
				search
			)}`,
			config
		);
	}
};

export const getServicePage = (id, config) => {
	let errors = [];
	if (!id) {
		errors.push("id");
	}
	if (errors.length) {
		return Promise.reject(Error(`${errors.join(", ")} parameters are missing!`));
	} else {
		return api.get(
			`/ServiceContent/ServiceDynamicContent/${id}`,
			config
		);
	}
};

export const getServicePages = (currentPage, PageSize, search, config) => {
	let errors = [];
	if (!currentPage) {
		errors.push("current page");
	}
	if (!PageSize) {
		errors.push("page size");
	}
	if (!config) {
		errors.push("config");
	}
	if (errors.length) {
		return Promise.reject(Error(`${errors.join(", ")} parameters are missing!`));
	} else {
		return api.get(
			`/ServiceContent/AllServiceDynamicContent?PageNumber=${currentPage}&PageSize=${PageSize}&search=${encodeURIComponent(
				search
			)}`,
			config
		);
	}
};

export const addServicePage = (loggedUser, token, servicePage) => {
	let errors = [];
	if (!loggedUser) {
		errors.push("Logged user");
	}
	if (!token) {
		errors.push("token");
	}
	if (!servicePage) {
		errors.push("servicePage");
	}
	if (errors.length) {
		return Promise.reject(Error(`${errors.join(", ")} parameters are missing!`));
	} else {
		return fetch(`${process.env.REACT_APP_URL}/ServiceContent/CreateServiceDynamicContent`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(servicePage),
		});
	}
};

export const updateServicePage = (loggedUser, token, servicePage) => {
	let errors = [];
	if (!loggedUser) {
		errors.push("Logged user");
	}
	if (!token) {
		errors.push("token");
	}
	if (!servicePage) {
		errors.push("servicePage");
	}
	if (errors.length) {
		return Promise.reject(Error(`${errors.join(", ")} parameters are missing!`));
	} else {
		return fetch(`${process.env.REACT_APP_URL}/ServiceContent/UpdateServiceDynamicContent`, {
			method: "PUT",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(servicePage),
		});
	}
};
